import { render, staticRenderFns } from "./SalesSubmissionNiche.vue?vue&type=template&id=2400c3e8&"
import script from "./SalesSubmissionNiche.vue?vue&type=script&lang=js&"
export * from "./SalesSubmissionNiche.vue?vue&type=script&lang=js&"
import style0 from "./SalesSubmissionNiche.vue?vue&type=style&index=0&id=2400c3e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports